export default __webpack_public_path__ + "static/media/5.16.ee1bf31b.mp3";